<template>
  <footer>浙ICP备**********号-1 / 京公网安备************号 / Powered by 2020 jingning</footer>
</template>

<script>
export default {
  name: 'footer',
  data() {
    return {
    }
  },
  components: {
    
  },
}
</script>
<style lang="less" scoped>
    footer{
        background: #4a4c60;
        line-height: 108px;
        color: #fff;
        text-align: center;
        font-size: 16px;
        width: 100%;
    }
</style>